import Joi from 'joi';

/**
 * Schema for new asset reservation record validation.
 */
export const createAssetReservationSchema = () =>
	Joi.object({
		startsAt: Joi.alternatives().conditional(Joi.any().valid(null), {
			then: Joi.invalid(null).messages({
				'any.invalid': 'validations|asset-reservation-starts-at|cannot-be-null',
			}),
			otherwise: Joi.date().required().messages({
				'any.required': 'validations|asset-reservation-starts-at|required',
				'date.base':
					'validations|asset-reservation-starts-at|must-be-a-valid-date',
			}),
		}),

		endsAt: Joi.alternatives().conditional(Joi.any().valid(null), {
			then: Joi.invalid(null).messages({
				'any.invalid': 'validations|asset-reservation-ends-at|cannot-be-null',
			}),
			otherwise: Joi.date().greater(Joi.ref('startsAt')).required().messages({
				'any.required': 'validations|asset-reservation-ends-at|required',
				'date.base':
					'validations|asset-reservation-ends-at|must-be-a-valid-date',
				'date.greater':
					'validations|asset-reservation-ends-at|cannot-be-before-starts-at',
			}),
		}),

		pickupLocationUuid: Joi.string().allow(null).messages({
			'string.base':
				'validations|asset-reservation-pickup-location-uuid|must-be-string',
		}),

		dropOffLocationUuid: Joi.string().allow(null).messages({
			'string.base':
				'validations|asset-reservation-dropoff-location-uuid|must-be-string',
		}),

		files: Joi.any().allow(null),
	})
		// Ignore extra fields
		.unknown();
